import { initialStateSession } from './session/initialStates';
import { type SessionState } from './session/types';
import { initialState } from './settings/initialStates';
import { type SettingState } from './settings/types';
import { initialUserState } from './user/initialState';
import { type UserState } from './user/types';

const getPreloadedSessionState = (): SessionState => {
  return initialStateSession;
};

const getPreloadedUserState = (): UserState => {
  return initialUserState;
};

const getPreloadedSettings = (): SettingState => {
  return initialState;
};

const getPreloadedState = () => {
  return {
    session: getPreloadedSessionState(),
    user: getPreloadedUserState(),
    settings: getPreloadedSettings(),
  };
};

export default getPreloadedState;
